//ブック追加画面
import React, { useState } from 'react';
import styled from 'styled-components';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { generateBookId, addBook } from '../redux/bookDbSlice'
import { addRelationUserBook } from '../redux/relationUserBookDbSlice';
import { addRelationFolderBook } from '../redux/relationFolderBookDbSlice';
import useCurrentUserId from '../hooks/useCurrentUserId';
import useCurrentFolderId from '../hooks/useCurrentFolderId'
import useAllBookDbsInFolder from '../hooks/useAllBookDbsInFolder';

const AddBookDialogContent = styled(DialogContent)`
  width: 30vw;
`;
const BookNameTextField = styled(TextField)`
  width: 90%;
`;

type AddBookDialogProps = {
  open: boolean;
  onClose: () => void;
  transitionStart: (id: string, order: number) => void;
}
const AddBookDialog: React.FC<AddBookDialogProps> = ({ open, onClose, transitionStart }) => {
  const dispatch = useDispatch();
  const userId = useCurrentUserId();
  const currentFolderId = useCurrentFolderId();
  const [bookIds] = useAllBookDbsInFolder(currentFolderId);
  const [value, setValue] = useState('新しいブック');

  const addBookExe = () => {
    const bookId = generateBookId();
    dispatch(addBook({ id: bookId, name: value, notes: 'ブック説明' }));
    dispatch(addRelationUserBook({userId: userId || 'no user', bookId: bookId}));
    dispatch(addRelationFolderBook({userId: userId || 'no user', folderId: currentFolderId || 'no folder', bookId: bookId, order: bookIds.length}));
    transitionStart(bookId, bookIds.length);
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogTitle></DialogTitle>
      <AddBookDialogContent style={{overflow: 'hidden'}}>
        <BookNameTextField label="新しいブックの名前" variant="outlined" defaultValue={value} 
                            onChange={(e) => setValue(e.target.value)}/>
      </AddBookDialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={() => addBookExe()}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddBookDialog;
